export const DASHBOARD_ACTIVITY = 'DASHBOARD_ACTIVITY';
export const DASHBOARD_ACTIVITY_SUCCESS = 'DASHBOARD_ACTIVITY_SUCCESS';
export const DASHBOARD_ACTIVITY_ERROR = 'DASHBOARD_ACTIVITY_ERROR';

export const DASHBOARD_REPAIRS = 'DASHBOARD_REPAIRS';
export const DASHBOARD_REPAIRS_SUCCESS = 'DASHBOARD_REPAIRS_SUCCESS';
export const DASHBOARD_REPAIRS_ERROR = 'DASHBOARD_REPAIRS_ERROR';

export const DASHBOARD_DINNING = 'DASHBOARD_DINNING';
export const DASHBOARD_DINNING_SUCCESS = 'DASHBOARD_DINNING_SUCCESS';
export const DASHBOARD_DINNING_ERROR = 'DASHBOARD_DINNING_ERROR';